<template>
  <div>
    <template v-if="state != null">
      <template v-if="state.report != null">
        <v-row align="center">
          <v-col cols="12" md="6" lg="8">
            <div class="headline mb-4">KCT- TRANSFORMATIVE PERSONALITY</div>
            <v-card elevation="0" outlined>
              <v-card-text>
                <div>
                  <div>
                    <div
                      style="color: #224f84; font-size: 16px; font-weight: bold"
                      class="mb-4"
                    >
                      ผลการประเมินจัดอยู่ในกลุ่ม
                      {{ state.report.myGroup.key }}
                    </div>
                    <div>
                      <template
                        v-if="typeof state.report.myGroup.desc == 'string'"
                      >
                        {{ state.report.myGroup.desc }}
                      </template>
                      <template v-else>
                        <p
                          v-for="(paragraph, idx) of state.report.myGroup.desc"
                          :key="`paragraph_${idx}`"
                        >
                          {{ paragraph }}
                        </p>
                      </template>
                    </div>
                  </div>
                  <v-divider class="my-4"></v-divider>
                  <div
                    style="color: #224f84; font-size: 16px; font-weight: bold"
                    class="pb-4"
                  >
                    การฝึกอบรมที่ต้องการเป็นพิเศษ
                  </div>
                  <p>
                    {{ state.report.myPattern.desc }}
                  </p>
                </div>
                <v-divider class="my-4"></v-divider>
                <div class="text-center">
                  <v-btn
                    :color="'blue darken-2'"
                    dark
                    depressed
                    @click="openPlayer"
                  >
                    {{ btnText }}
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" lg="4" align-self="center">
            <div
              class="text-center mx-auto"
              :style="{
                'max-width': '450px',
              }"
            >
              <canvas id="myChart" style="width: 100%; height: auto"></canvas>
              <!-- <apexchart
              type="radar"
              :options="options"
              :series="series"
              :height="$vuetify.breakpoint.mdAndUp ? 'auto' : 270"
            ></apexchart> -->
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <div class="headline mb-4">KCT- TRANSFORMATIVE PERSONALITY</div>
        <v-card elevation="0" outlined>
          <v-card-text>
            <div v-if="formDetail != null">
              {{ formDetail.formDesc }}
            </div>
            <div class="mt-4">
              <v-btn
                :color="'blue darken-2'"
                dark
                depressed
                @click="openPlayer"
              >
                {{ btnText }}
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </template>
    </template>
    <template v-else>
      <div class="headline mb-4">KCT- TRANSFORMATIVE PERSONALITY</div>
      <v-skeleton-loader type="article, actions"></v-skeleton-loader>
    </template>
  </div>
</template>

<script>
import Vue from "vue";
import { EventBus } from "../../event-bus";
import evalService, { formKey } from "../../services/evaluateService";
import Chart from "chart.js/auto";

export default {
  data: () => ({
    state: null,
    options: {
      fill: {
        opacity: 0.5,
        colors: ["#BBDEFB"],
      },
      plotOptions: {
        radar: {
          size: 120,
          polygons: {
            strokeColors: "#e9e9e9",
            fill: {
              colors: ["#f8f8f8", "#fff"],
            },
          },
        },
      },
      responsive: [
        {
          breakpoint: 960,
          options: {
            plotOptions: {
              radar: {
                size: 60,
              },
            },
          },
        },
      ],
      markers: {
        size: 0,
        strokeColor: "#BBDEFB",
        strokeWidth: 2,
      },
      tooltip: {
        enabled: false,
        y: {
          formatter: function (val) {
            return val;
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return `${val.toFixed(1)}%`;
        },
      },
      labels: [],
      xaxis: {
        categories: [
          "Creativity",
          ["Interdependent", "Collabolative", "Mindset"],
          "Handle Pressure",
          ["Self Leading", "/Self Motivation"],
        ],
        labels: {
          style: {
            // fontSize: "11px",
            colors: ["#616161", "#616161", "#616161", "#616161"],
          },
        },
      },
      yaxis: {
        show: false,
        tickAmount: 4,
        max: 100,
        min: 0,
        labels: {
          formatter: function (val, i) {
            return `${val}%`;
          },
        },
      },
      legend: {
        show: false,
        height: 0,
        width: 0,
      },
      chart: {
        toolbar: {
          show: false,
        },
      },
    },
    chartOptions: {
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          callbacks: {
            label: (item, data) => {
              return `${Vue.$utility.roundNumber(item.raw, 1)}%`;
            },
          },
        },
      },
      elements: {
        line: {
          borderWidth: 3,
        },
      },
      scales: {
        r: {
          min: 0,
          suggestedMax: 100,
          pointLabels: {
            font: {
              size: 13,
            },
          },
          ticks: {
            stepSize: 20,
            precision: 1,
          },
        },
      },
    },
    series: [
      {
        name: "Real Score",
        data: [],
      },
    ],
    chartjsData: null,
    chartInstance: null,
    formDetail: null,
  }),
  created() {
    window.addEventListener("message", this.onEvaluateFinish);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.onEvaluateFinish);
  },
  mounted() {
    this.init();
  },
  computed: {
    btnText() {
      if (this.state.continue) {
        // do nothing
        return "ทำแบบทดสอบต่อ";
      } else {
        if (this.isFresh) {
          return `เริ่มทำแบบทดสอบ`;
        } else {
          return `ทำแบบทดสอบใหม่`;
        }
      }
    },
    isFresh() {
      if (this.state != null) {
        // not has active session and has been evaluate more than 1 times
        if (this.state.continue == false && this.state.report == null) {
          return true;
        }
      }

      return false;
    },
    skipReport() {
      if (this.state != null) {
        // not has active session and has been evaluate more than 1 times
        if (this.state.continue == false && this.state.report != null) {
          return true;
        }
      }

      return false;
    },
  },
  methods: {
    init() {
      this.state = null;
      evalService
        .getFormByKey(formKey)
        .then((form) => {
          if (form != null) {
            this.formDetail = form;
            return evalService.getPreviewReport(form.courseId);
          } else {
            throw new Error(`No have evaluate form : ${formKey}`);
          }
        })
        .then((resp) => {
          this.state = resp.data;
          if (this.state.report != null) {
            this.updateChartDataChartJS(this.state.report);
          }
        })
        .catch((err) => {
          this.state = null;
        });
    },
    openPlayer() {
      // this.skipReport = false;
      // console.log(this.formDetail.courseId);
      EventBus.$emit("evalIdentity", this.formDetail.courseId, this.skipReport);
    },
    updateChartDataChartJS(data) {
      let seriesData = [];
      let labels = [];
      for (const skill of data.skills) {
        labels.push(skill.name);
        seriesData.push(skill.percentage);
      }

      this.chartjsData = {
        labels: [
          "Creativity",
          ["Interdependent", "Collabolative", "Mindset"],
          "Handle Pressure",
          ["Self Leading", "/Self Motivation"],
        ],
        datasets: [
          {
            label: "",
            data: seriesData,
            fill: true,
            pointRadius: 5,
            backgroundColor: "rgba(25, 118, 210, 0.2)",
            borderColor: "rgba(25, 118, 210, 0.7)",
            pointBackgroundColor: "rgb(25, 118, 210)",
            pointBorderColor: "#fff",
            pointHoverBackgroundColor: "#fff",
            pointHoverBorderColor: "rgb(255, 99, 132)",
          },
        ],
      };

      this.$nextTick(() => {
        // destroy it before re-render
        if (this.chartInstance != null) {
          this.chartInstance.destroy();
        }

        var ctx = document.getElementById("myChart");
        this.chartInstance = new Chart(ctx, {
          type: "radar",
          data: this.chartjsData,
          options: this.chartOptions,
        });
      });
    },
    updateChartData(data) {
      // update series & labels
      let seriesData = [];
      let labels = [];
      for (const skill of data.skills) {
        labels.push(skill.name);
        seriesData.push(skill.percentage);
      }

      // find max value
      // const maxScoreSkill = data.summary.skills.reduce(function (
      //   prev,
      //   current
      // ) {
      //   return prev.total > current.total ? prev : current;
      // });

      this.options = {
        ...this.options,
        labels: labels,
        yaxis: {
          ...this.options.yaxis,
          // max: maxScoreSkill.total + 1,
        },
      };
      // seriesData.push(4);
      // seriesData.push(5);
      this.series = [
        {
          name: "Real Score",
          data: seriesData,
        },
      ];
    },
    onEvaluateFinish(evt) {
      // console.log(evt);
      switch (evt.data) {
        case "close":
          this.init(); // update chart
          break;
        default:
          // do nothing
          break;
      }
    },
  },
};
</script>